import React from "react";
import { Hero } from "../components/Hero";
import { TopMarquee } from "../components/TopMarquee";
import { Method } from "../components/Method";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1592342001587-51d958a5bed3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function Landing() {
  return (
    <>
      <Hero heroImage={HERO_IMAGE} />
      <TopMarquee />
      <Method />
      <footer className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 border-t border-[var(--border-heavy)] relative z-10">
        <div className="font-serif-display text-[28px] text-[#1C2430] mb-2">The MLA-C01 From-Zero Study Guide</div>
        <p className="font-mono-ui text-[11px] uppercase tracking-[0.18em] text-[#1C2430]/50">
          Week one was the reading · then it was all practice questions · good luck.
        </p>
      </footer>
    </>
  );
}
